import styled from 'styled-components'
import { FaCheck } from 'react-icons/fa'

export const ListItem = styled.li`
  margin: 5px;
  padding: 5px;
  color: #fff;
  border-radius: 5px;
  background-color: #333;
`

export const Li = styled.li`
  margin: 5px;
  padding: 5px;
`

export const InfoItem = styled.span`
  margin: 5px;
  padding: 5px;
  color: #fff;
  border-radius: 5px;
  background-color: #222;
`

export const DirectLinkImportContainer = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
`

export const ImportContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
`

export const ImportSteps = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 20px;
`

export const ImportSingleStep = styled.div`
  display: flex;
  align-items: center;
  cursor: ${(props) =>
    props.completed || props.active ? 'default' : 'pointer'};
  transition: all 0.3s ease;

  ${(props) =>
    !props.completed &&
    !props.active &&
    `
    &:hover .step-value {
      border-color: #00aeef;
      background-color: #f0f9ff;
    }
  `}
`

export const StepValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  text-align: center;
  border-radius: 50%;
  margin-right: 10px;
  border: 1px solid #cbd5e0;
  background-color: #fff;
  color: #cbd5e0;
  font-size: 14px;
  transition: all 0.3s ease;

  ${(props) =>
    props.active &&
    `
    border: 1px solid transparent;
    background-color: #00aeef;
    color: #fff;
  `}

  ${(props) =>
    props.completed &&
    `
    border: 1px solid transparent;
    background-color: #38a169;
    color: #fff;
  `}
`

export const StepLabel = styled.span`
  color: ${(props) =>
    props.active || props.completed ? '#2d3748' : '#a0aec0'};
  font-weight: ${(props) =>
    props.active || props.completed ? '600' : 'normal'};
  font-size: 14px;
  transition: all 0.3s ease;
`

export const StepContent = styled.div`
  display: ${(props) => (props.active ? 'block' : 'none')};
`

export const ImportSection = styled.div`
  margin-bottom: 30px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SectionTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  color: #2d3748;
  font-size: 18px;
  font-weight: 400;
`

export const StepNumber = styled.span`
  display: inline-block;
  vertical-align: middle;
  width: 35px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border-radius: 50%;
  margin-right: 10px;
  border: 1px solid #00aeef;
  background-color: #fff;
  color: #00aeef;
`

export const DropdownContainer = styled.div`
  .campaign-dropdown {
    width: 100%;

    select {
      width: 100%;
      padding: 12px 16px;
      border: 2px solid #e2e8f0;
      border-radius: 8px;
      font-size: 16px;
      background: white;
      transition: all 0.2s ease;

      &:focus {
        outline: none;
        border-color: #00aeef;
        box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
      }

      &:hover {
        border-color: #cbd5e0;
      }
    }
  }
`

export const FileUploadContainer = styled.div`
  margin-top: 10px;
`

export const FilesDropzone = styled.div`
  border: 2px dashed ${(props) => (props.dragActive ? '#00aeef' : '#cbd5e0')};
  border-radius: 12px;
  padding: 40px 20px;
  background: ${(props) => (props.dragActive ? '#f0f9ff' : '#f8fafc')};
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    border-color: #00aeef;
    background: #f0f9ff;
  }
`

export const UploadZone = styled.div`
  text-align: center;
`

export const UploadZoneContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

export const UploadText = styled.div`
  text-align: center;
`

export const UploadTitle = styled.p`
  font-size: 18px;
  color: #2d3748;
  margin: 0 0 8px 0;
`

export const UploadSubtitle = styled.p`
  font-size: 14px;
  color: #718096;
  margin: 0;
`

export const FilePreview = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-top: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`

export const FileIcon = styled.div`
  font-size: 24px;

  &.excel {
    color: #217346;
  }

  &.csv {
    color: #00aeef;
  }

  &.default {
    color: #718096;
  }
`

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
`

export const FileName = styled.span`
  color: #2d3748;
  font-size: 14px;
`

export const RemoveFileButton = styled.button`
  background: none;
  border: none;
  color: #e53e3e;
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;

  &:hover {
    background: #fed7d7;
  }
`

export const UploadButton = styled.button`
  background: #00aeef;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 14px 28px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 20px;
  width: 100%;

  &:hover:not(:disabled) {
    background: #0a6ba8;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(14, 131, 205, 0.3);
  }

  &:disabled {
    background: #a0aec0;
    cursor: not-allowed;
    transform: none;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 20px;
`

export const LoadingText = styled.p`
  color: #718096;
  font-size: 16px;
  margin: 0;
`

export const AcceptedFilesInfo = styled.div`
  background: #f0f9ff;
  border: 1px solid #bee3f8;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
`

export const AcceptedFilesTitle = styled.p`
  color: #2d3748;
  margin: 0 0 8px 0;
  font-size: 14px;
`

export const FileTypesList = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`

export const FileTypeItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #4a5568;
`

export const CheckIcon = styled(FaCheck)`
  font-size: 14px;
`

export const DescriptionBox = styled.div`
  background: #f0f9ff;
  border: 1px solid #bee3f8;
  border-radius: 8px;
  padding: 24px;
  margin: 20px 0;
  line-height: 1.6;
`

export const DescriptionTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #2d3748;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 16px 0;
`

export const DescriptionList = styled.div`
  margin: 16px 0;
`

export const DescriptionItem = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  align-items: flex-start;

  &:last-child {
    margin-bottom: 0;
  }
`

export const RequiredBadge = styled.span`
  background: #e53e3e;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  min-width: 80px;
  text-align: center;
  flex-shrink: 0;
`

export const OptionalBadge = styled.span`
  background: #718096;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  min-width: 80px;
  text-align: center;
  flex-shrink: 0;
`

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  background: #f0fff4;
  border: 1px solid #9ae6b4;
  border-radius: 12px;
  margin: 20px 0;
`

export const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  background: #38a169;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(56, 161, 105, 0.3);
`

export const SuccessTitle = styled.h3`
  color: #2d3748;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 16px 0;
`

export const SuccessMessage = styled.p`
  color: #4a5568;
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
  max-width: 500px;
`

export const DownloadButton = styled.button`
  background: #38a169;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #2f855a;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(56, 161, 105, 0.3);
  }
`

export const NewImportButton = styled.button`
  background: #00aeef;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #0a6ba8;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(14, 131, 205, 0.3);
  }
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
`

export const ErrorTitle = styled.h3`
  color: #d32f2f;
  margin: 0 0 16px 0;
  font-size: 24px;
  font-weight: 600;
`

export const ErrorMessage = styled.p`
  color: #6b7280;
  font-size: 16px;
  line-height: 1.5;
  margin: 0 0 24px 0;
  max-width: 500px;
`
